import { cn, isHoliday, isWeekend } from '@jobcost-monorepo/utils';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import * as React from 'react';
import { DayPicker } from 'react-day-picker';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  const isWeekendOrHoliday = (date: Date) => isWeekend(date) || isHoliday(date);

  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      captionLayout="dropdown"
      fromYear={1970}
      toYear={new Date().getFullYear() + 10}
      className={cn('p-3', className)}
      classNames={{
        caption_dropdowns: 'flex justify-center space-x-2',
        vhidden: 'hidden',
        dropdown: 'max-h-20 overflow-y-auto bg-transparent',
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4',
        caption: 'flex justify-center pt-1 relative items-center',
        caption_label: 'hidden text-sm font-medium',
        nav: 'space-x-1 flex items-center',
        nav_button: 'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
        nav_button_previous: 'absolute left-1',
        nav_button_next: 'absolute right-1',
        table: 'w-full border-collapse space-y-1',
        head_row: 'flex',
        head_cell:
          'text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]',
        row: 'flex w-full mt-2',
        cell: 'text-center text-sm p-0 relative rounded-md [&:has([aria-selected])]:bg-pink focus-within:relative focus-within:z-20 hover:opacity-80',
        day: 'h-9 w-9 p-0 font-normal rounded-md aria-selected:opacity-100',
        day_selected: 'bg-pink text-white dark:bg-pink dark:!text-white',
        day_today:
          'text-black !font-extrabold dark:!text-white dark:!font-extrabold',
        day_outside:
          'text-muted-foreground opacity-50 dark:text-muted-foreground dark:opacity-50',
        day_disabled:
          'text-muted-foreground opacity-50 dark:text-muted-foreground dark:opacity-50',
        day_range_middle:
          'aria-selected:bg-accent aria-selected:text-accent-foreground',
        day_hidden: 'invisible',
        ...classNames,
      }}
      components={{
        IconLeft: () => <ChevronLeft className="h-4 w-4" />,
        IconRight: () => <ChevronRight className="h-4 w-4" />,
      }}
      modifiers={{ holiday: isWeekendOrHoliday }}
      modifiersClassNames={{
        holiday: 'text-red dark:text-red',
      }}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
